/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AufgabeModelRequest { 
    beschreibung?: string;
    erinnerung_fix_wochentag?: number;
    erinnerung_relativ_minuten?: number;
    erinnerung_relativ_tage?: number;
    erinnerung_uhrzeit_fix_minuten?: number;
    erinnerung_uhrzeit_fix_stunden?: number;
    ist_eskalation_an_veranstaltungsleiter_aktiv?: boolean;
    eskalation_fix_wochentag?: number;
    eskalation_relativ_minuten?: number;
    eskalation_relativ_tage?: number;
    eskalation_uhrzeit_fix_minuten?: number;
    eskalation_uhrzeit_fix_stunden?: number;
    ist_erinnerung_aktiv?: boolean;
    ist_erinnerung_uhrzeit_fix?: boolean;
    ist_erinnerung_wochentag_fix?: boolean;
    ist_eskalation_aktiv?: boolean;
    ist_eskalation_an_abarbeiter_aktiv?: boolean;
    ist_eskalation_an_freigeber_checkliste_aktiv?: boolean;
    ist_eskalation_an_freigeber_funktionsbereich_aktiv?: boolean;
    ist_eskalation_uhrzeit_fix?: boolean;
    ist_eskalation_wochentag_fix?: boolean;
    ist_optional?: boolean;
    ist_veranstaltungsrelevant?: boolean;
    referenz_zeitpunkt?: string;
    reihenfolge?: number;
    relation?: string;
    titel: string;
    optional_standard_aktiviert?: boolean;
    bild_ids?: Array<string>;
    checkliste_id: string;
    funktionsbereich_id: string;
    aufgabe_id: string;
    position?: number;
}

